export default  [
  {
    "planNumber": "805222",
    "planName": "HUBBELL AE JOIN EMP(805222) SAVINGS AND INVESTMENT PLAN ",
    "planType": null,
    "clientNumber": "800342",
    "clientName": "HUBBELL INCORPORATED                    ",
    "phoneNumber": "1-877-123-4567",
    "centuryPlan": false,
    "recordKeeper": "rec_keeper_omniplus",
    "planCategoryCode": "1",
    "planCategoryName": "401K                                    ",
    "tracPlan": false,
    "terminated": false
  },
  {
    "planNumber": "104556",
    "planName": "HYATT CORPORATION (MASKED) RETIREMENT SAVINGS PLAN ",
    "planType": null,
    "clientNumber": "101956",
    "clientName": "HYATT CORPORATION                       ",
    "phoneNumber": "1-800-922-9945",
    "centuryPlan": false,
    "recordKeeper": "rec_keeper_omniplus",
    "planCategoryCode": "1",
    "planCategoryName": "401K                                    ",
    "tracPlan": false,
    "terminated": false
  },
  {
    "planNumber": "905222",
    "planName": "COSTCO (MASKED) RETIREMENT SAVINGS PLAN ",
    "planType": null,
    "clientNumber": "101956",
    "clientName": "HYATT CORPORATION                       ",
    "phoneNumber": "1-800-922-9945",
    "centuryPlan": false,
    "recordKeeper": "rec_keeper_omniplus",
    "planCategoryCode": "1",
    "planCategoryName": "401K                                    ",
    "tracPlan": false,
    "terminated": false
  }
]
